export interface ICalculatorResult {
  hoursSaved: number
  extraTicketsHandled: number
  revenueSaved: number
}

export default function (
  averageTickets: number,
  minutesPerTicket: number,
  averageHourlySalary: number,
): ICalculatorResult {
  if (averageTickets < 0 || minutesPerTicket < 0 || averageHourlySalary < 0)
    throw new Error('Non-negative inputs required.')

  const percentageHuman = 0.36
  const revenueSpentMonth = averageTickets * (minutesPerTicket / 60) * averageHourlySalary
  const selfServeArticlesRate = 0.08
  const proactiveSupportRate = 0.06
  const selfServeResolutionBotRate = 0.07

  const revenueSavedMonthHuman = percentageHuman * revenueSpentMonth
  const timeSpentHoursMonth = averageTickets * (minutesPerTicket / 60)
  const timeSavedHoursHuman = timeSpentHoursMonth - (1 - percentageHuman) * timeSpentHoursMonth
  const revenueSavedMonthAutomated =
    (selfServeArticlesRate + proactiveSupportRate + selfServeResolutionBotRate) * revenueSpentMonth
  const timeSavedHoursAutomated =
    (selfServeArticlesRate + proactiveSupportRate + selfServeResolutionBotRate) *
    timeSpentHoursMonth
  const revenueSaved = revenueSavedMonthHuman + revenueSavedMonthAutomated
  const hoursSaved = timeSavedHoursHuman + timeSavedHoursAutomated
  const extraTicketsHandled = hoursSaved / (minutesPerTicket / 60)

  return {
    hoursSaved: Math.trunc(hoursSaved),
    extraTicketsHandled: Math.trunc(extraTicketsHandled),
    revenueSaved: Math.trunc(revenueSaved),
  }
}
